import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppBar, Box, Toolbar, IconButton, Typography, Menu, Container, Button, MenuItem, Tooltip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useLoaderData } from 'react-router-dom';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import ThemeToggle from '../components/ThemeToggle';

function NavigationBar() {
  const { socials } = useLoaderData();
  const [anchorElNav, setAnchorElNav] = useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const pages = [
    { name: 'Work', icon: fas.faBriefcase, path: '/work' },
    { name: 'Education', icon: fas.faGraduationCap, path: '/education' },
    { name: 'Projects', icon: fas.faCode, path: '/projects' }
  ];

  const socialLinks = [
    { name: 'Github', icon: fab.faSquareGithub, url: socials.github },
    { name: 'LinkedIn', icon: fab.faLinkedin, url: socials.linkedin },
    { name: 'Facebook', icon: fab.faSquareFacebook, url: socials.facebook }
  ];

  return (
    <AppBar position="sticky" color="default" elevation={2}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* Logo/Brand for larger screens */}
          <Typography
            variant="h6"
            noWrap
            component={Link}
            to="/home"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontWeight: 700,
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            Naga Venkata Satish, Divvi
          </Typography>

          {/* Mobile menu */}
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page) => (
                <MenuItem 
                  key={page.name} 
                  onClick={handleCloseNavMenu}
                  component={Link}
                  to={page.path}
                >
                  <Typography textAlign="center">
                    <FontAwesomeIcon icon={page.icon} /> {page.name}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          {/* Logo/Brand for mobile */}
          <Typography
            variant="h5"
            noWrap
            component={Link}
            to="/home"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontWeight: 700,
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            NVS Divvi
          </Typography>

          {/* Desktop menu */}
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Button
                key={page.name}
                component={Link}
                to={page.path}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: 'inherit', display: 'flex', alignItems: 'center', gap: 1 }}
              >
                <FontAwesomeIcon icon={page.icon} /> {page.name}
              </Button>
            ))}
          </Box>

          {/* Theme Toggle and Social Links */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <ThemeToggle />
            {socialLinks.map((social, index) => (
              <Tooltip key={index} title={social.name}>
                  <IconButton href={social.url} target="_blank" color="inherit">
                    <FontAwesomeIcon icon={social.icon} />
                  </IconButton>
              </Tooltip>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default NavigationBar;